import { useState } from 'react'
import Image from 'next/legacy/image'
import cn from 'classnames'
// Components
import Button from '../newButton/Button'
import AmbassadorModal from './AmbassadorModal'
// Utils
import { convertPrice } from '../../components/puppyProfile/lib/utils'
import useMediaQuery from '../../utils/publicApi'
import TCModal from './TCModal'
import styles from './cover.module.scss'

const Cover = ({ ambassadorData }) => {
  const isTablet = useMediaQuery('(max-width:1270px)')
  const [openModal, setOpenModal] = useState(false)
  const [openModalTC, setOpenModalTC] = useState(false)
  const [userRegisterd, setUserRegisterd] = useState(false)
  const sharingTextSocialMedia = `Mawoo Pets is the go-to platform to find the perfect puppy for your family from a reputable breeder. Get a ${convertPrice(
    ambassadorData?.amount
  )} discount on your first puppy 🐶 adoption through their website using this link: ${
    process.env.NEXT_PUBLIC_ROOT_URL
  }/referral/user/${ambassadorData?.code} `
  const sharingTextEmail = `Hi%20there!%0A%0AI%20just%20joined%20the%20Mawoo%20Pets%20Referral%20Program%20and%20I%20wanted%20to%20share%20this%20deal%20with%20you.%20Mawoo%20Pets%20is%20the%20go-to%20platform%20to%20find%20the%20perfect%20puppy%20for%20your%20family%20from%20a%20reputable%20breeder.%20You%20can%20use%20my%20link%20below%20for%20a%20${convertPrice(
    ambassadorData?.amount
  )}%20discount%20on%20your%20first%20puppy%20adoption%20through%20their%20website.%0A%0AHere%20is%20my%20referral%20link%3A%0A%F0%9F%91%89%20${
    process.env.NEXT_PUBLIC_ROOT_URL
  }/referral/user/${
    ambassadorData?.code
  }%0A%0AWhen%20you%20use%20my%20referral%20link%20to%20adopt%20your%20first%20puppy,%20I'll%20also%20receive%20a%20${convertPrice(
    ambassadorData?.amount
  )}%20Amazon%20gift%20card%20as%20a%20thank-you%20from%20Mawoo%20Pets.%20%0A%0AI%20hope%20you%20are%20able%20to%20find%20the%20perfect%20puppy%20to%20bring%20love%20and%20joy%20to%20your%20family.%20Happy%20puppy%20hunting%20and%20enjoy%20your%20${convertPrice(
    ambassadorData?.amount
  )}%20discount%20at%20Mawoo%20Pets!%20%F0%9F%90%BE`
  return (
    <div className={styles.coverContainer}>
      <div className={styles.backgroundCover} />

      <div className={styles.container}>
        <div className={styles.cardsContainer}>
          {!ambassadorData?.verified ? (
            <div className={styles.breedCardSummary}>
              {/* //  DATA WITHOUT CODE */}
              {isTablet && <h4>Spread the love! </h4>}
              <h1>Give $75, Get $75!</h1>
              <p>
                For every friend you refer to Mawoo Pets, you’ll get a $75
                Amazon gift card and they’ll get $75 off their puppy purchase!*
              </p>
              {userRegisterd ? (
                <div className={styles.userRegisterd}>
                  <h3>Thanks for signing up!</h3>
                  <p className={styles.text}>
                    To access your unique code check your email.
                  </p>
                </div>
              ) : (
                <div className={styles.btnContainer}>
                  <Button
                    title="Unlock your unique code"
                    onClick={() => setOpenModal(true)}
                    theme={['medium', 'green-solid']}
                  />
                </div>
              )}

              <span className={styles.terms}>
                *
                <div
                  onClick={() => setOpenModalTC(true)}
                  className={styles.text}
                >
                  Terms and Conditions
                </div>
                apply.{' '}
              </span>
            </div>
          ) : (
            <div className={styles.breedCardSummary}>
              {/* //  DATA WITH CODE */}
              <h1>
                Thanks for joining our <br />
                Ambassador Program!
              </h1>
              <p className={styles.data}>
                Share your unique referral code with friends and family via SMS,
                Email, Whatsapp, Facebook, or Twitter.
              </p>

              <div className={styles.codeContainer}>
                <h2>{ambassadorData?.code}</h2>
              </div>
              {/* SOCIAL MEDIA */}
              <div className={styles.socialMedia}>
                <a
                  href={`mailto:?subject=%F0%9F%90%BE%20Get%20${convertPrice(
                    ambassadorData?.amount
                  )}%20Discount%20at%20Mawoo%20Pets&body=${sharingTextEmail}`}
                >
                  <div className={styles.iconEmail} />
                </a>
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=${
                    process.env.NEXT_PUBLIC_ROOT_URL +
                    '/referral/user/' +
                    ambassadorData?.code
                  }`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className={styles.iconFb} />
                </a>

                <a
                  href={`https://twitter.com/intent/tweet?text=${sharingTextSocialMedia}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className={styles.iconTw} />
                </a>
                <a
                  href={`https://api.whatsapp.com/send?text=${sharingTextSocialMedia}`}
                  data-action="share/whatsapp/share"
                >
                  <div className={styles.iconWp} />
                </a>
                {isTablet && (
                  <a href={`sms:&body=${sharingTextSocialMedia}"`}>
                    <div className={styles.iconSms} />
                  </a>
                )}
              </div>
            </div>
          )}
          {/* Desktop Cover Image */}
          <div className={cn(styles.imageHolder, styles.desktopImageHolder)}>
            <Image
              width={528}
              height={370}
              src="/referral/girl-kissing-dog.webp"
              className={cn(styles.imageHolder, styles.desktopImageHolder)}
              layout="fixed"
              alt=""
            />
          </div>
          {/* Mobile Cover Image */}
          <div className={cn(styles.imageHolder, styles.mobileImageHolder)}>
            <Image
              width={375}
              height={220}
              src="/referral/girl-kissing-dog-mobile.webp"
              className={cn(styles.imageHolder, styles.mobileImageHolder)}
              alt=""
              layout="responsive"
              objectFit="fill"
              quality={100}
            />
          </div>
        </div>
      </div>
      {openModal && (
        <AmbassadorModal
          setUserRegisterd={setUserRegisterd}
          isOpen={openModal}
          close={() => setOpenModal(false)}
        />
      )}
      {openModalTC && (
        <TCModal isOpen={openModalTC} close={() => setOpenModalTC(false)} />
      )}
    </div>
  )
}

export default Cover
